import { render } from "./CoursePreview.vue?vue&type=template&id=58cb9724&scoped=true"
import script from "./CoursePreview.vue?vue&type=script&lang=js"
export * from "./CoursePreview.vue?vue&type=script&lang=js"

import "./CoursePreview.vue?vue&type=style&index=0&id=58cb9724&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58cb9724"]])

export default __exports__